/* eslint-disable no-unused-vars */
import { userService } from '../../services'
import Candidato from '../../model/Candidato'

export default {
  state: {
    user: new Candidato(),
    erro: null,
    token: null
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setToken(state, payload) {
      state.token = payload
    },
    setErro(state, payload) {
      state.erro = payload
    }
  },
  actions: {
    async signUserIn({ commit }, payload) {
      await userService.login().then(o => {
        if (o.token) {
          commit('setUser', o.usuario)
          commit('setToken', o.token)
        } else {
          commit('setErro', o.error)
        }
      })
    },
    async storeUser({ commit }, payload) {
      return userService.storeUser();
    },
    async pickVaga({ commit }, payload) {

      return userService.pickVaga(payload);
    },
    setarUsuario({ commit }, payload) {
      commit('setUser', payload.usuario)
      commit('setToken', payload.token)
      
    },
    setSair({ commit }) {
      commit('setUser', new Candidato())
      commit('setToken', null)
    },
    async verificaCPF({ commit }, payload) {
      await userService.verificaCPF(payload).then(o => {
        let _user = new Candidato();
        _user.cpf = payload;
        if (o.id) {
          _user.id = o.id;
          _user.nome = o.nome;
          commit('setUser', _user)
          commit('setToken', null)
        } else {
          commit('setErro', o.error)
        }
        commit('setUser', _user)
        commit('setToken', null)
      })


    },
    async trocaSenha({ commit }, payload) {
      await userService.trocaSenha(payload).then(o => {
        if (o.token) {
          commit('setToken', o.token)
        } else {
          commit('setErro', o.error)
        }
      })
    },
  },
  getters: {
    getUser(state) {
      return state.user
    },
    getToken(state) {
      return state.token
    },
    getErro(state) {
      return state.erro
    }
  }
}
